exports.components = {
  "component---src-templates-page-js": () => import("./../../../src/templates/page.js" /* webpackChunkName: "component---src-templates-page-js" */),
  "component---src-templates-pdp-template-js": () => import("./../../../src/templates/pdp_template.js" /* webpackChunkName: "component---src-templates-pdp-template-js" */)
}

